<template>
  <b-modal
    :visible="value"
    :title="modalTitle"
    ok-only
    ok-title="Close"
    @change="$emit('input', $event)"
  >
    <b-overlay :show="loading" rounded="sm">
      <div v-if="amendments.length" class="amendment-history-list">
        <div
          v-for="(a, i) in amendments"
          :key="i"
          class="amendment-history-row"
        >
          <div class="amendment-history-change">
            {{ a.previous_quantity }} → {{ a.new_quantity }}
          </div>
          <div class="amendment-history-meta">
            by {{ a.amended_by }} · {{ formatDate(a.amended_at) }}
          </div>
        </div>
      </div>
      <p v-else class="text-muted mb-0">No amendments yet.</p>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  name: 'PlantEntryAmendmentHistoryModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    entryId: {
      type: Number,
      default: null,
    },
    plantName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: false,
      amendments: [],
    }
  },

  computed: {
    modalTitle() {
      return this.plantName
        ? `Amendment History - ${this.plantName}`
        : 'Amendment History'
    },
  },

  watch: {
    value(open) {
      if (open) this.fetchHistory()
    },
  },

  methods: {
    async fetchHistory() {
      this.loading = true
      try {
        this.amendments = await this.$store.dispatch(
          'plantEquipment/getPlantEntryAmendments',
          this.entryId,
        )
      } catch (err) {
        this.$bvToast.toast(
          'Failed to load amendment history. Please try again.',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          },
        )
      } finally {
        this.loading = false
      }
    },

    formatDate(iso) {
      if (!iso) return ''
      return new Date(iso).toLocaleString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
}
</script>

<style scoped>
.amendment-history-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.amendment-history-row {
  border-bottom: 1px solid #f3f4f6;
  padding-bottom: 8px;
}

.amendment-history-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.amendment-history-change {
  font-weight: 600;
  font-size: 14px;
}

.amendment-history-meta {
  font-size: 12px;
  color: #6b7280;
}
</style>
